import { isPreviewRevisionUnread } from '@renderer/overlay/hooks/conversation-preview-acknowledgements'
import type { RecentActivity } from '@renderer/overlay/Sidepanel/types'

/**
 * Whether a history item is a chat with an unread response. Only chats carry the revisions.
 *
 * Kept apart from `activity-helpers`, whose `@renderer/chat` import reaches into Electron's `app`
 * and so can't be loaded in a unit test.
 */
export function isActivityUnread(item: RecentActivity): boolean {
  if (item.type !== 'chat' || item.previewRevision === undefined) return false
  return isPreviewRevisionUnread(item.id, item.previewRevision, item.previewAcknowledgedRevision)
}
